import assert from "assert"
import { distinctArrayOfNumber, distinctArrayOfDeviceTreeGroupElements } from "utils/distinct"
import arraySort from "array-sort"
import { IDeviceTreeGroupElement } from "@types"
export const compareNumber = (obj1: number[], obj2: number[]) => {
 try {
  assert.deepStrictEqual(distinctArrayOfNumber(obj1.sort()), distinctArrayOfNumber(obj2.sort()))
  return true
 } catch (err) {
  return false
 }
}

export const compareDeviceGroupElements = (
 collection1: IDeviceTreeGroupElement[],
 collection2: IDeviceTreeGroupElement[],
) => {
 try {
  if (!collection2.length) return false
  assert.deepStrictEqual(
   arraySort(distinctArrayOfDeviceTreeGroupElements([...collection1]), "device_id"),
   arraySort(distinctArrayOfDeviceTreeGroupElements([...collection2]), "device_id"),
  )
  return true
 } catch (err) {
  return false
 }
}
